"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaggingParser = void 0;
/**
 * A parser used for calculate/overwrite the logic needed for the tags on each market
 */
class TaggingParser {
  constructor() {
    /**
     * This will overwrite the tags calculations and use basic cost instead
     */
    this.shouldCalculateBasicCost = false;
  }
}
exports.TaggingParser = TaggingParser;